module.exports = __webpack_public_path__ + "img/bingo_ball-10.6d6ed6d4.png";